// extracted by mini-css-extract-plugin
export var isPrintedCell = "_ya-1";
export var printerIcon = "_ya-0";